<link rel="stylesheet"
    href="https://fonts.googleapis.com/icon?family=Material+Icons">
<header class="cy-secure-header">
    <mat-toolbar color='primary' id="header" class="cyToolbar">
        <mat-toolbar-row>
            <span class="logo">
                <h1 class="header-title">Cypher System</h1>
            </span>
            <span class="header-gap" aria-hidden="true"></span>
            <span class="header-spacer"></span>
            <div *ngIf="activeInspection && activeInspection.number"
                class="inspection-meta-group">
                <span class="inspection-meta">
                    Inspection No :
                    {{activeInspection?.number}}
                </span>
                <span
                    *ngIf="activeInspection.totalAmount"
                    class="inspection-meta">
                    Total Amount:
                    ${{activeInspection?.totalAmount}}
                </span>
                <span
                    *ngIf="activeInspection.totalPaid"
                    class="inspection-meta">
                    Total Paid:
                    ${{activeInspection?.totalPaid}}
                </span>
                <span
                    *ngIf="activeInspection.balance"
                    class="inspection-meta">
                    Balance Due:
                    ${{activeInspection?.balance}}
                </span>
            </div>
            <span class="header-spacer"></span>
            <app-theme-toggle></app-theme-toggle>
            <button mat-icon-button
                    type="button"
                    [matMenuTriggerFor]="appMenu"
                    aria-label="Open application menu">
                <mat-icon class="headerIcons" aria-hidden="true">apps</mat-icon>
            </button>
            <button mat-icon-button
                    type="button"
                    [matMenuTriggerFor]="personMenu"
                    aria-label="Open user menu">
                <mat-icon class="headerIcons" aria-hidden="true">person</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
</header>
<!--    Other options
        fa-solid fa-magnifying-glass
        fa-solid fa-file-lines
        fa-solid fa-folder-open
        fa-solid fa-eye
        fa-solid fa-list-ul
        fa-solid fa-list-ol
        fa-calendar fa-calendar-alt fa-calendar-check fa-list-check
        fa-bell fa-bell-o fa-exclamation-circle
        fa-solid fa-ticket-alt fa-solid fa-ta fa-solid fa-envelope-open-text
        fa-solid fa-check-square fa-solid fa-clipboard-check fa-solid fa-cog
        fa-chart-line fa-chart-bar fa-chart-pie fa-table fa-magnifying-glass-chart
-->
<mat-menu #appMenu="matMenu" class="app-menu-grid">
    <div class="menu-grid">
        <button mat-menu-item (click)="gotoDashboard()"
                *ngIf="hasPermission(permissionModule.DASHBOARD)">
            <i class="fa-solid fa-gauge-high menu-icon"></i>
            <span class="menu-label">Dashboard</span>
        </button>
        <button mat-menu-item (click)="gotoCaseProcessing()"
                *ngIf="hasPermission(permissionModule.CITATION)">
            <i class="fa-solid fa-balance-scale menu-icon"></i>
            <span class="menu-label">Citations</span>
        </button>
        <button mat-menu-item (click)="gotoInspections()"
                *ngIf="hasPermission(permissionModule.VIN_SYSTEM)">
            <i class="fa-solid fa-car menu-icon"></i>
            <span class="menu-label">Inspections</span>
        </button>
        <button mat-menu-item (click)="gotoCaseQueue()"
                *ngIf="hasPermission(permissionModule.CASE_QUEUE)">
            <i class="fa-solid fa-list-ul menu-icon"></i>
            <span class="menu-label">Court Queue</span>
        </button>
        <button mat-menu-item (click)="gotoFormTemplates()"
                *ngIf="hasFormsMenuAccess()">
            <i class="fa-solid fa-file-lines menu-icon"></i>
            <span class="menu-label">Forms</span>
        </button>
        <button mat-menu-item (click)="gotoCaseWorkflow()"
                *ngIf="hasPermission(permissionModule.CASE_WORKFLOW)">
            <i class="fa-solid fa-diagram-project menu-icon"></i>
            <span class="menu-label">Case Workflow</span>
        </button>
        <button mat-menu-item (click)="gotoBailBond()"
                *ngIf="hasPermission(permissionModule.BOND_SYSTEM)">
            <i class="fa-solid fa-handcuffs menu-icon"></i>
            <span class="menu-label">Bond Providers</span>
        </button>
        <button mat-menu-item (click)="gotoProbation()"
                *ngIf="hasPermission(permissionModule.PROBATION_SYSTEM)">
            <i class="fa-solid fa-user-check menu-icon"></i>
            <span class="menu-label">Probations</span>
        </button>
        <button mat-menu-item (click)="gotoCaseActions()"
                *ngIf="hasPermission(permissionModule.CASE_ACTION)">                    
            <i class="fa-solid fa-tasks menu-icon"></i>
            <span class="menu-label">Case Audit</span>
        </button>
        <button mat-menu-item (click)="gotoDockets()"
                *ngIf="hasPermission(permissionModule.DOCKET)">
            <i class="fa-solid fa-list-ol menu-icon"></i>
            <span class="menu-label">Dockets</span>
        </button>
        <button mat-menu-item (click)="gotoCourtCalendar()"
                *ngIf="!isProsecutor()
                    && isCourtCalendarVisible()">
            <i class="fa-regular fa-calendar menu-icon"></i>
            <span class="menu-label">Court Calendar</span>
        </button>
        <button mat-menu-item (click)="gotoProsecutorCalendar()"
                *ngIf="isProsecutor()
                    && isCourtCalendarVisible()">
            <i class="fa-regular fa-calendar menu-icon"></i>
            <span class="menu-label">Calendar</span>
        </button>
        <button mat-menu-item (click)="gotoInspection()"
                *ngIf="hasPermission(permissionModule.VIN_SYSTEM)">
            <i class="fa-solid fa-tools menu-icon"></i>
            <span class="menu-label">Inspection</span>
        </button>
        <button mat-menu-item (click)="gotoInspectionsCalendar()"
                *ngIf="hasPermission(permissionModule.VIN_SYSTEM)">
            <i class="fa-regular fa-calendar-check menu-icon"></i>
            <span class="menu-label">Inspection Calendar</span>
        </button>
        <button mat-menu-item (click)="gotoMessages()"
                *ngIf="hasPermission(permissionModule.DMV_AGENCY_SYSTEM)">
            <i class="fa-solid fa-bell menu-icon"></i>
            <span class="menu-label">Notifications</span>
        </button>
        <button mat-menu-item (click)="gotoTickets()"
                *ngIf="hasPermission(permissionModule.DMV_AGENCY_SYSTEM)">
            <i class="fa-solid fa-ticket-alt menu-icon"></i>
            <span class="menu-label">Tickets</span>
        </button>
        <button mat-menu-item (click)="gotoCompliance()"
                *ngIf="hasPermission(permissionModule.DMV_AGENCY_SYSTEM)">
            <i class="fa-solid fa-check-square menu-icon"></i>
            <span class="menu-label">Update Common Code</span>
        </button>
        <button mat-menu-item (click)="gotoAnalytic()"
                *ngIf="hasPermission(permissionModule.DMV_AGENCY_SYSTEM)">
            <i class="fa-solid fa-magnifying-glass-chart menu-icon"></i>
            <span class="menu-label">Analytic Reporting</span>
        </button>
        <button mat-menu-item (click)="gotoJuryModule()"
                *ngIf="hasPermission(permissionModule.JURY_SYSTEM)">
            <span class="fa-stack menu-icon">
                <i class="fas fa-landmark fa-stack-2x"></i>
                <i class="fas fa-users fa-stack-1x jury-stack-users"></i>
            </span>
            <span class="menu-label">Jury</span>
        </button>
        <!-- Add more menu items as needed -->
    </div>
</mat-menu>
<mat-menu #personMenu="matMenu">
    <button mat-menu-item (click)="gotoSetting()">
        <i class="material-icons person-menu-icon">settings</i>
        <span>Settings</span>
    </button>
    <button mat-menu-item
        *ngIf="canManageSystemSettings()"
        (click)="gotoSystemSetting()">
        <i class="material-icons person-menu-icon">
            admin_panel_settings
        </i>
        <span>System Settings</span>
    </button>
    <button mat-menu-item
        *ngIf="isSuper() || hasUserAdminAccess()"
        (click)="gotoUsers()">
        <i class="material-icons person-menu-icon">group</i>
        <span>Users</span>
    </button>
    <button mat-menu-item (click)="signOut()">
        <i class="material-icons person-menu-icon">logout</i>
        <span>Sign Out</span>
    </button>
</mat-menu>
